import { defineMessages } from 'react-intl';

export const commonMessages = defineMessages({
  continue: {
    defaultMessage: 'Continue',
    id: 'AddCredentialsPage.continue',
  },
  logIn: {
    defaultMessage: 'Log in',
    id: 'AddCredentialsPage.authenticate',
  },
  cancel: {
    defaultMessage: 'Cancel',
    id: 'common.cancel',
  },
  retry: {
    defaultMessage: 'Retry',
    id: 'common.retry',
  },
  back: {
    defaultMessage: 'Back',
    id: 'common.back',
  },
  learnMore: {
    defaultMessage: 'Learn more',
    id: 'common.learnMore',
  },
  submit: {
    defaultMessage: 'Submit',
    id: 'common.submit',
  },
  ok: {
    defaultMessage: 'OK',
    id: 'ok',
  },
  search: {
    defaultMessage: 'Search',
    id: 'ChooseProvider.search',
  },
  pleaseTryAgain: {
    defaultMessage: 'Please try again.',
    id: 'PleaseTryAgain',
  },
  bank: {
    defaultMessage: 'Bank',
    id: 'common.bank',
  },
  agree: {
    defaultMessage: 'Agree',
    id: 'common.agree',
  },
  verify: {
    defaultMessage: 'Verify',
    id: 'common.verify',
  },
  none: {
    defaultMessage: 'None',
    id: 'common.none',
  },
});
